import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18392c14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table-filters",
  "data-test": "table-filters"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19.893 3.001H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h15.893c1.103 0 2-.897 2-2V5a2.003 2.003 0 0 0-2-1.999zM8 19.001H4V8h4v11.001zm6 0h-4V8h4v11.001zm2 0V8h3.893l.001 11.001H16z" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Columns", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "flex gap-2 table-filters__dropdown__option"
}
const _hoisted_6 = ["disabled", "checked", "onChange"]

import { ref, onMounted } from 'vue';

type TableHeader = { id: string; label: string; align?: string; sortable?: boolean };


export default /*#__PURE__*/_defineComponent({
  __name: 'TableFilters',
  props: {
    columns: {},
    ariaLabel: {}
  },
  emits: ["updateColumns"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isColumnFilterOpen = ref(false);
const checkedColumns = ref(props.columns ? [...props.columns] : []);

const isColumnChecked = (columnId: string): boolean => {
	return !!checkedColumns.value?.find((col) => col.id === columnId);
};

const handleColumnToggle = (isChecked: boolean, column: TableHeader) => {
	const columnIndexInColumns = props.columns.findIndex((col) => col.id === column.id);
	const columnIndexInChecked = checkedColumns.value.findIndex((col) => col.id === column.id);

	if (isChecked && columnIndexInChecked === -1) {
		let composedIndex;

		if (columnIndexInColumns > checkedColumns.value?.length / 2) {
			composedIndex =
				columnIndexInColumns - (props.columns.length - checkedColumns.value.length - 1);
		} else {
			composedIndex = columnIndexInColumns;
		}

		checkedColumns.value.splice(composedIndex, 0, column);
	} else {
		checkedColumns.value.splice(columnIndexInChecked, 1);
	}

	if (props.ariaLabel)
		localStorage.setItem(props.ariaLabel, JSON.stringify(checkedColumns.value));

	emit('updateColumns', checkedColumns.value);
};

onMounted(() => {
	if (props.ariaLabel && localStorage.getItem(props.ariaLabel)) {
		checkedColumns.value = JSON.parse(localStorage.getItem(props.ariaLabel)!);

		emit('updateColumns', checkedColumns.value);
	}
});

const resetColumns = () => {
	if (props.ariaLabel && localStorage.getItem(props.ariaLabel))
		localStorage.removeItem(props.ariaLabel);

	checkedColumns.value = [...props.columns];
	emit('updateColumns', checkedColumns.value);
};

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("caption", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass([
				'table-filters__columns-btn',
				{ 'table-filters__columns-btn--active': isColumnFilterOpen.value },
			]),
      "aria-label": "Filter columns",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isColumnFilterOpen.value = !isColumnFilterOpen.value))
    }, _hoisted_4, 2),
    _createElementVNode("ul", {
      class: _normalizeClass([
				'table-filters__dropdown',
				{ 'table-filters__dropdown--visible': isColumnFilterOpen.value },
			])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `column-${column.id}`,
          class: "mt-1"
        }, [
          (column.label)
            ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
                _createElementVNode("input", {
                  type: "checkbox",
                  disabled: checkedColumns.value.length <= 3 && isColumnChecked(column.id),
                  checked: isColumnChecked(column.id),
                  onChange: ($event: any) => (handleColumnToggle($event.target.checked, column))
                }, null, 40, _hoisted_6),
                _createTextVNode(" " + _toDisplayString(column.label), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("button", {
        class: "table-filters__dropdown__reset-btn",
        onClick: resetColumns
      }, " Reset columns ")
    ], 2)
  ])), [
    [_directive_click_outside, () => (isColumnFilterOpen.value = false)]
  ])
}
}

})